import { UIText2 } from '@cian/ui-kit';

import { useMemo } from 'react';

import { type TModifier, useFiltersContext } from '@/packages/Filters';
import { RangeInput } from '@/packages/Filters/shared/components/RangeInput';
import { PETERSBURG_AND_REGION } from '@/packages/Filters/shared/constants/regions';
import { getRegionId } from '@/packages/Filters/shared/utils/geo';
import { useDebouncedCallback } from '@/packages/Filters/shared/utils/useDebouncedCallback';
import type { NonEmptyArray, TJsonQuery } from '@/packages/JsonQuery';

import { HighwayModalHeader } from '../components/HighwaysModalHeader';

export function HighwaysModalHeaderContainer({
  onChange,
  jsonQuery,
}: {
  onChange: (...modifiers: NonEmptyArray<TModifier>) => void;
  jsonQuery: TJsonQuery;
}): JSX.Element {
  const fromMKAD = useMemo(() => {
    return jsonQuery.from_mcad_km?.value;
  }, [jsonQuery.from_mcad_km]);
  const { currentLocation } = useFiltersContext();

  const label = useMemo(() => {
    const locationId = getRegionId(currentLocation);

    return `Расстояние ${PETERSBURG_AND_REGION.includes(locationId) ? 'от КАД' : 'от МКАД'}`;
  }, [currentLocation]);

  const handleChangeMax = useDebouncedCallback(
    (value: number): void => {
      onChange({
        action: 'setFromMKADMax',
        arguments: [value],
      });
    },
    300,
    [fromMKAD, onChange],
  );

  const handleChangeMin = useDebouncedCallback(
    (value: number): void => {
      onChange({
        action: 'setFromMKADMin',
        arguments: [value],
      });
    },
    300,
    [fromMKAD, onChange],
  );

  return (
    <HighwayModalHeader>
      <UIText2>{label}</UIText2>
      <HighwayModalHeader.Inputs>
        <RangeInput
          max={9999}
          min={1}
          postfix="км"
          valueMax={fromMKAD?.lte}
          valueMin={fromMKAD?.gte}
          onChangeMax={handleChangeMax}
          onChangeMin={handleChangeMin}
        />
      </HighwayModalHeader.Inputs>
    </HighwayModalHeader>
  );
}
